import React from 'react';
import { Container } from 'reactstrap';
import {
    DashboardPageHeader,
    ComingSoonCard,
    ModuleLandingGrid,
    ModuleShortcutCard,
} from '../../Components/Common/DashboardKit';

/**
 * Supervisor module landing page.
 *
 * UI-only refactor (Pass 1):
 *  - Swapped video <ComingSoon> for <ComingSoonCard>.
 *  - Added shortcuts to existing approval workflows supervisors
 *    already use: Personal Attendance (FTO/COA awaiting approval),
 *    EPO (expense approvals), and Task Management. All three
 *    routes already exist; we're just surfacing them.
 *
 * Route is wrapped in <RoleProtected requireSuperUser> in
 * allRoutes.js. Linked routes have their own auth handling.
 */
const Supervisor = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-user-settings-line"
                        eyebrow="Oversight"
                        title="Supervisor"
                        subtitle="Team oversight and approvals"
                        tone="violet"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Supervisor" },
                        ]}
                    />

                    <ModuleLandingGrid
                        title="Approvals & oversight"
                        icon="ri-inbox-archive-line"
                        description="Quick links to items that need your attention"
                    >
                        <ModuleShortcutCard
                            icon="ri-calendar-2-line"
                            label="FTO & COA Approvals"
                            subtitle="Approve your team's free-time-off and change-of-address requests"
                            tone="primary"
                            to="/attendance/approvals"
                        />
                        <ModuleShortcutCard
                            icon="ri-ticket-2-line"
                            label="Expense Purchase Orders"
                            subtitle="Review and approve EPOs"
                            tone="warning"
                            to="/epo"
                        />
                        <ModuleShortcutCard
                            icon="ri-task-line"
                            label="Task Management"
                            subtitle="View tasks assigned to your team"
                            tone="info"
                            to="/task-management"
                        />
                        <ModuleShortcutCard
                            icon="ri-team-line"
                            label="Organizational Chart"
                            subtitle="See your team structure"
                            tone="success"
                            to="/organizational-chart"
                        />
                    </ModuleLandingGrid>

                    <ComingSoonCard
                        icon="ri-user-settings-line"
                        title="Team analytics are coming soon"
                        message="Direct-report performance summaries, attendance overviews, and team KPI rollups will land here."
                        tone="primary"
                        features={[
                            "Direct-report attendance overview",
                            "Pending approvals dashboard",
                            "Team performance summaries",
                            "Goal and KPI tracking",
                        ]}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Supervisor;
